module.exports = __webpack_public_path__ + "static/media/maintenance-door.8e312748.gif";